import { useRef } from 'react';

function generateRandomNumber(): number {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0];
}

export function useNumericId() {
  const idRef = useRef<number | null>(null);

  if (idRef.current === null) {
    idRef.current = generateRandomNumber();
  }

  return idRef.current;
}

export default useNumericId;
